import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

import { signUp } from "./../slices/auth";
import { canopy } from "./../theme";
import AuthLayout from "./AuthLayout";

export default function SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      await dispatch(
        signUp({
          email: data.get("email"),
          password: data.get("password"),
          firstName: data.get("firstName"),
          lastName: data.get("lastName"),
          role: "user",
        }),
      ).unwrap();
      const from = location.state?.from?.pathname || "/account";
      navigate(from, { replace: true });
    } catch (error) {
      console.warn(Error);
    }
  };

  return (
    <AuthLayout subtitle="Create your resident account">
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="given-name"
              name="firstName"
              required
              fullWidth
              id="firstName"
              label="First name"
              autoFocus
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              id="lastName"
              label="Last name"
              name="lastName"
              autoComplete="family-name"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              id="email"
              label="Email address"
              name="email"
              autoComplete="email"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="new-password"
            />
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ mt: 3 }} alignItems="center">
          <Button type="submit" fullWidth variant="contained" size="large">
            Create account
          </Button>
          <Typography sx={{ fontSize: 14, color: "text.secondary", fontWeight: 600 }}>
            Already have an account?{" "}
            <Link
              to="/signin"
              style={{ color: canopy.green, fontWeight: 800, textDecoration: "none" }}
            >
              Sign in
            </Link>
          </Typography>
        </Stack>
      </Box>
    </AuthLayout>
  );
}
